import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NotificationDisplay from './NotificationDisplay';
import { removeNotification } from 'portfolio-shared/state/commands/globalNotificationsCommands';
import { getNotifications } from 'state/selectors';

class GlobalNotifications extends Component {
  static propTypes = {
    notifications: PropTypes.array.isRequired,
    removeNotification: PropTypes.func.isRequired,
  };

  render() {
    return (
      <NotificationDisplay
        notifications={this.props.notifications}
        onRemoveNotification={this.props.removeNotification}
      />
    );
  }
}

export default connect(
  state => ({ notifications: getNotifications(state) }),
  dispatch => bindActionCreators({ removeNotification }, dispatch)
)(GlobalNotifications);



// WEBPACK FOOTER //
// ./src/view/App/NotificationDisplay/GlobalNotifications.js